import {
  CalendarText,
  DropDownIcon,
  DropDownMenu,
  DropDownMenuList,
  FlyoutMenu,
  PaymentAnalyticsContainer,
  PaymentAnalyticsHeader,
  PaymentLinkTitleText,
  YearFilter,
} from "../DashboardReturningUsers/DashboardReturningUsers.styles";
import { LuCalendarDays } from "react-icons/lu";
import { colors } from "../../theme/color";
import { drop_down } from "../../../public/assets";
import EmptyDashBoard from "../../components/DashBoardComponents/EmptyDashBoard";
import React, { useState } from "react";

type EmptyAnalyticsProps = React.PropsWithChildren<{
  title: string;
}>;
export const EmptyAnalytics: React.FC<EmptyAnalyticsProps> = ({ title }) => {
  const [isDropDown, setIsDropDown] = useState(false);
  const [selectedYear, setSelectedYear] = useState("2023");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const years = ["2023", "2024", "2025", "2026"];

  const handleDropDownMenu = () => {
    setIsDropDown(!isDropDown);
  };

  const handleSelectedIndex = (index: number) => {
    setSelectedIndex(index);
    console.log(selectedIndex);
    setSelectedYear(years[index]);
    console.log(selectedYear);
    setIsDropDown(!isDropDown);
    console.log(isDropDown);
  };
  return (
    <PaymentAnalyticsContainer>
      <PaymentAnalyticsHeader>
        <PaymentLinkTitleText>{title}</PaymentLinkTitleText>
        <FlyoutMenu>
          <YearFilter onClick={handleDropDownMenu}>
            <LuCalendarDays
              color={colors.ButtonBackgroundColors.primaryDefaultButton}
              size={"20px"}
            />
            <CalendarText>Year {selectedYear} </CalendarText>
            <DropDownIcon
              src="/assets/icons/Drop_Down.png"
              onClick={handleDropDownMenu}
            />
          </YearFilter>

          <DropDownMenu isDropDown={isDropDown}>
            {years.map((year, index) => (
              <DropDownMenuList
                selected={selectedIndex === index}
                key={year}
                onClick={() => handleSelectedIndex(index)}
              >
                {year}
              </DropDownMenuList>
            ))}
          </DropDownMenu>
        </FlyoutMenu>
      </PaymentAnalyticsHeader>
      <EmptyDashBoard
        titleText="No analytics"
        subtitleText="All analytics will be displayed here"
      />
      <br />
      <br />
      <br />
      <br />
    </PaymentAnalyticsContainer>
  );
};
